import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { EditableNote, MarkDownNotes, styled } from '@streem/ui-react';
import { useRoomSession, useRoomSessionDetections, useStreemshotResponses, } from '../../../context/room_session';
import { useObservable } from '../../../hooks/rxjs';
import { ModelSerialList } from './model_serial_list/model_serial_list';
import { dedupeDetections } from '../../../util/detection_helpers';
import { RecentCallsLogForHostUser } from './recent_calls_log_host';
import { useCompanySettings } from '../../../context/company_settings';
import { SpectatorNotes } from './spectator_notes';
export const LegacyInCallNotes = () => {
    const roomSession = useRoomSession();
    const companySettings = useCompanySettings();
    const roomSessionDetections = useRoomSessionDetections();
    const [note] = useObservable(roomSession.note.roomNote);
    const [errorMessage, setErrorMessage] = useState('');
    const handleSaveNote = useCallback((updatedNotes) => {
        roomSession.note.saveRoomNote(updatedNotes);
    }, [roomSession]);
    const dedupedDetections = dedupeDetections(roomSessionDetections);
    const streemshots = useStreemshotResponses();
    const [isEditingYn, setIsEditingYn] = useState(false);
    const noteText = note?.text ?? '';
    const showMarkdownYn = !isEditingYn && noteText.length > 0;
    const noteEditorEnabled = companySettings?.editorNotesEnabled;
    const onEdit = useCallback(() => {
        setIsEditingYn(true);
    }, []);
    const onSave = (noteText) => {
        setErrorMessage('');
        try {
            handleSaveNote(noteText);
            setIsEditingYn(false);
        }
        catch (error) {
            setErrorMessage('Error attempting to edit note.');
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(NoteSection, { noteEditorEnabled: noteEditorEnabled, showMarkdownYn: showMarkdownYn, noteText: noteText, onEdit: onEdit, onSave: onSave, errorMessage: errorMessage, companySettings: companySettings }), _jsx(ModelSerialListWrapper, { children: _jsx(ModelSerialList, { modelSerialDetections: dedupedDetections, streemshots: streemshots }) }), _jsx(RecentCallsLogForHostUser, { currentRoomId: roomSession.roomId.toString() })] }));
};
const NoteSection = ({ noteEditorEnabled, showMarkdownYn, noteText, onEdit, onSave, errorMessage, companySettings, }) => {
    if (noteEditorEnabled)
        return _jsx(SpectatorNotes, {});
    if (showMarkdownYn) {
        return _jsx(MarkDownNotes, { text: noteText, onEdit: onEdit, showTitle: false });
    }
    return (_jsx(EditableNote, { hasFootBar: false, description: "", placeholderText: 'Add notes', characterLimit: companySettings?.roomNoteCharLimit || 1700, noteText: noteText, errorMessage: errorMessage, onSave: onSave }));
};
const ModelSerialListWrapper = styled.div({
    marginTop: '40px',
});
//# sourceMappingURL=legacy_in_call_notes.js.map